import React from "react";

const Index = () => null;

export default Index;
